module.exports = __webpack_public_path__ + "static/media/thermometer-empty.d78b30fa.svg";